/**
 * Redação de PII para strings de telemetria.
 *
 * Mensagem de erro e stack trace são texto livre gerado pelo runtime — na
 * imensa maioria dos casos só têm nome de função e caminho de arquivo, mas
 * nada impede que um erro carregue um valor de campo junto ("Invalid CPF
 * 123.456.789-00"). Como `credit_v2_user_events` é uma tabela de telemetria
 * (retenção longa, leitura ampla), tudo que entra passa por aqui primeiro.
 *
 * Regra do projeto (security-guidelines §6): nunca logar CPF, CNPJ, telefone
 * ou e-mail. O que sobra — nome de arquivo, nome de componente, número de
 * linha — é justamente o que serve pra diagnosticar.
 */

const PATTERNS: Array<[RegExp, string]> = [
  // E-mail
  [/[\w.+-]+@[\w-]+\.[\w.-]+/g, "[email]"],
  // CPF formatado — 123.456.789-00
  [/\b\d{3}\.\d{3}\.\d{3}-\d{2}\b/g, "[cpf]"],
  // CNPJ formatado — 12.345.678/0001-90
  [/\b\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}\b/g, "[cnpj]"],
  // Qualquer corrida longa de dígitos (CPF/CNPJ sem máscara, id de documento).
  // 8+ dígitos seguidos não aparece em stack trace legítimo — linha e coluna
  // de arquivo são números curtos. Vem ANTES do telefone de propósito: sem
  // isso, o padrão de telefone abocanha um CPF sem máscara e o rotula errado.
  [/\d{8,}/g, "[num]"],
  // Telefone brasileiro formatado — (11) 91234-5678 / +55 11 91234-5678
  [/(?:\+\d{2}\s?)?\(?\d{2}\)?[\s-]?\d{4,5}-\d{4}\b/g, "[fone]"],
]

/** Remove padrões de PII conhecidos e corta no limite informado. */
export function redactPII(input: unknown, maxLen = 500): string | null {
  if (input == null) return null
  let text = typeof input === "string" ? input : String(input)
  for (const [pattern, replacement] of PATTERNS) {
    text = text.replace(pattern, replacement)
  }
  return text.slice(0, maxLen)
}
